import automation from "../../api/automation";
import { perPageCount } from "@/common/constants";
import { dummyRows, StatusIcon, convertCount } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    recipientsLoaded: false,
    segmentsLoaded: false,
    formsLoaded: false,
    itemLoaded: false,
    contactList: [],
    segmentList: [],
    formList: [],
    totalList: 0,
    totalSegment: 0,
    totalForm: 0,
    listLoading: false,
    campListLoading: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      camp_name: "",
      date_from: "",
      date_to: "",
      senderId: "",
      status: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
      add_sort: 0,
    },
    totalItems: 0,
    total: 0,
    busyLoaderStatus: true,
    createOrEdit: "",
    showFilter: false,
    editItem: {},
    listCamps: [],
    campTotalCount: 0,
    createReplaceIndex: "",
    duplicatingAutomationId: "",
    campaignOwnerAutomation: "",
    isEditAutomation: true,
    isLoadedPreview: false,
    firstRule: [],
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    var tempItem = [];
    for (var i = 0; i < state.items.length; i++) {
      var status = state.items[i].status_label;
      var openRate = 0;
      if (state.items[i].opens > 0) {
        openRate =
          state.items[i].sent > 0
            ? (state.items[i].opens / state.items[i].sent) * 100
            : 0;
        openRate = openRate.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        openRate = openRate.replace(".00", "");
      }
      tempItem.push({
        id: state.items[i].id,
        name: {
          title: state.items[i].name,
          text: "Created at " + state.items[i].createddate,
        },
        sent: convertCount(state.items[i].sent ? state.items[i].sent : 0),
        opens: {
          first: openRate + "%",
          second: convertCount(state.items[i].opens ? state.items[i].opens : 0),
        },
        cam_status: {
          text: state.items[i].status_label,
          type: StatusIcon(state.items[i].status_label),
        },
        cam_actions: {
          Edit: status !== "Draft" && status !== "Inactive",
          Duplicate:
            state.items[i].is_camp_exist === 1
              ? status !== "Draft" &&
                status !== "Active" &&
                status !== "Inactive" &&
                status !== "Scheduled" &&
                status !== "Completed"
              : true,
          Delete: status !== "Draft" && status !== "Scheduled",
          Activate: status !== "Inactive",
          Deactivate: status !== "Active" && status !== "Scheduled",
        },
      });
    }
    return tempItem;
  },

  getRecipients: (state) => {
    var tempList = [];
    for (var i = 0; i < state.contactList.length; i++) {
      var data = state.contactList[i];
      tempList.push({
        id: data.id,
        name: data.listname,
        update: data.latest_date,
        contacts: data.active,
      });
    }
    return tempList;
  },

  getSegments: (state) => {
    var tempList = [];
    for (var i = 0; i < state.segmentList.length; i++) {
      var data = state.segmentList[i];
      tempList.push({
        id: data.id,
        name: data.name,
        update: data.latest_date,
        contacts: data.activeCount,
      });
    }
    return tempList;
  },

  getForms: (state) => {
    var tempList = [];
    for (var i = 0; i < state.formList.length; i++) {
      var data = state.formList[i];
      tempList.push({
        id: data.id,
        name: data.name,
        update: data.latest_date,
        contacts: data.activeCount,
      });
    }
    return tempList;
  },

  getContactList: (state) => {
    return state.contactList.map((item) => {
      state.totalSubscribers = state.totalSubscribers + item.count;
      return { value: item.id, text: item.name, count: item.count };
    });
  },

  getSegmentList: (state) => {
    return state.segmentList.map((item) => {
      return { value: item.id, text: item.name, count: item.count };
    });
  },

  getFormList: (state) => {
    return state.formList.map((item) => {
      return { value: item.id, text: item.name, count: item.count };
    });
  },
};

// actions
const actions = {
  updateRulesAndCamps(_, params) {
    return automation.updateRulesAndCamps(params);
  },

  getCamps({ commit }, params) {
    commit("setCampListLoading", true);
    return automation.getCamps(params).then((response) => {
      commit("setListCamps", response.data.data);
      commit("setCampListLoading", false);
      return response.data.count;
    });
  },

  clearSingleItem({ commit }) {
    commit("setItemLoaded", false);
    commit("setEditItem", "");
    commit("setEditItem", {});
  },

  fetchSingleItem({ commit, state }, params) {
    params.isPreview = !!params.isPreview;
    if (!params.isPreview) {
      if (state.isLoadedPreview) {
        commit("setItemLoaded", false);
        commit("setIsLoadedPreview", false);
      }
    } else {
      commit("setIsLoadedPreview", true);
    }
    if (
      !state.itemLoaded ||
      state.editItem.encid !== params.id ||
      params.isPreview
    ) {
      commit("setItemLoaded", false);
      commit("setEditItem", { id: params.id });
      automation.getSingleItem(params.id, params.isPreview).then((response) => {
        commit("setEditItem", { ...response.data, encid: params.id });
        commit("setItemLoaded", true);
      });
    }
  },

  fetchSingleItemRouting(_, params) {
    return automation.getSingleItem(params.id).then((response) => {
      return response.data;
    });
  },

  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.camp_name !== params.camp_name ||
      filter.date_from !== params.date_from ||
      filter.date_to !== params.date_to ||
      filter.senderId !== params.senderId ||
      filter.status !== params.status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve, reject) {
        automation.fetchItems(params, (data) => {
          if (data.message) {
            reject(data.message);
          }
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },

  fetchRecipients({ commit, state }, params) {
    if (!state.recipientsLoaded) {
      commit("setListLoading", true);
      automation.getRecipients(params, (data) => {
        commit("setRecipients", data.list);
        commit("setTotalList", data.count);
        commit("setRecipientsLoaded", true);
        commit("setListLoading", false);
      });
    }
  },

  fetchSegments({ commit, state }, params) {
    if (!state.segmentsLoaded) {
      commit("setListLoading", true);
      automation.getSegments(params, (data) => {
        commit("setSegments", data.list);
        commit("setTotalSegment", data.count);
        commit("setSegmentsLoaded", true);
        commit("setListLoading", false);
      });
    }
  },

  fetchForms({ commit, state }, params) {
    if (!state.formsLoaded) {
      commit("setListLoading", true);
      automation.getForms(params, (data) => {
        commit("setForms", data.list);
        commit("setTotalForm", data.count);
        commit("setFormsLoaded", true);
        commit("setListLoading", false);
      });
    }
  },

  saveData(_, params) {
    return automation.saveData(params);
  },

  duplicateAuto(_, params) {
    return automation.duplicateAuto(params);
  },

  saveName(_, params) {
    return automation.saveName(params);
  },

  deleteAutomation({ dispatch }, { id }) {
    return automation.delete(id).then(function () {
      dispatch("refreshItems");
    });
  },

  deleteAutomationCamp(_, { id, autoId }) {
    return automation.deleteCamp(id, autoId);
  },

  publishAuto(_, params) {
    return automation.publishAuto(params);
  },

  commonValidate(_, id) {
    return automation.commonValidate(id);
  },

  duplicateCamp(_, params) {
    return automation.duplicateCamp(params);
  },

  activateAuto(_, params) {
    return automation.activateAuto(params);
  },

  deactivateAuto(_, params) {
    return automation.deactivateAuto(params);
  },
};

// mutations
const mutations = {
  setDuplicatingAutomationId(state, id) {
    state.duplicatingAutomationId = id;
  },

  setCreateReplaceIndex(state, createReplaceIndex) {
    state.createReplaceIndex = createReplaceIndex;
  },

  setCampListLoading(state, isLoading) {
    state.campListLoading = isLoading;
  },

  setCampTotalCount(state, count) {
    state.campTotalCount = count;
  },

  setListCamps(state, items) {
    state.listCamps = items;
  },

  setEditItem(state, item) {
    state.editItem = item;
  },

  setItemName(state, name) {
    state.editItem.name = name;
  },

  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setCampaignOwnerAutomation(state, campaignOwnerAutomation) {
    state.campaignOwnerAutomation = campaignOwnerAutomation;
  },

  setIsEditAutomation(state, isEditAutomation) {
    state.isEditAutomation = isEditAutomation;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },

  setItemLoaded(state, loaded) {
    state.itemLoaded = loaded;
  },

  setIsLoadedPreview(state, loaded) {
    state.isLoadedPreview = loaded;
  },

  setRecipientsLoaded(state, loaded) {
    state.recipientsLoaded = loaded;
  },

  setSegmentsLoaded(state, loaded) {
    state.segmentsLoaded = loaded;
  },

  setFormsLoaded(state, loaded) {
    state.formsLoaded = loaded;
  },

  setRecipients(state, contactList) {
    state.contactList = contactList;
  },

  setSegments(state, segmentList) {
    state.segmentList = segmentList;
  },

  setForms(state, formList) {
    state.formList = formList;
  },

  setTotalList(state, totalList) {
    state.totalList = totalList;
  },

  setTotalSegment(state, totalSegment) {
    state.totalSegment = totalSegment;
  },

  setTotalForm(state, totalForm) {
    state.totalForm = totalForm;
  },

  setListLoading(state, listLoading) {
    state.listLoading = listLoading;
  },

  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },

  setShowFilter(state, status) {
    state.showFilter = status;
  },

  setTotal(state, total) {
    state.total = total;
  },

  setFirstRule(state, rule) {
    state.firstRule = rule;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
